<template functional>
  <div
    class="dataset-cell-text"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
  >
    {{ props.value }}
  </div>
</template>

<script>
export default {
  name: 'DatasetCellText',
  props: {
    row: { type: Object, default: () => ({}) },
    columns: { type: Object, default: () => ({}) },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: () => null,
    },
  },
}
</script>
